// extracted by mini-css-extract-plugin
export default {"navItem":"NavBarItem_navItem__g5MHZ","active":"NavBarItem_active__3hRXS","icon":"NavBarItem_icon__Bu8ZV","title":"NavBarItem_title__t7KIs","count":"NavBarItem_count__IyGXY"};